import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";

export const deleteOrganizationDocument = documentId => {
  return dispatch => {
    dispatch({ type: "DELETE_DOCUMENT_LOADING" });
    api
      .organizationDocumentDelete(documentId)
      .then(() => {
        dispatch(operationSucceeded(documentId));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFailed());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "DeleteOrganizationDocumentErrorAlertTitle",
          "Virhe poistaessa yrityksen dokumenttia",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = () => ({
  type: "DELETE_ORGANIZATION_DOCUMENT_SUCCEEDED",
});

const operationFailed = () => ({
  type: "DELETE_ORGANIZATION_DOCUMENT_FAIL"
});
